import { render, staticRenderFns } from "./ResendMessageButton.vue?vue&type=template&id=9d920d20&scoped=true&"
import script from "./ResendMessageButton.vue?vue&type=script&lang=js&"
export * from "./ResendMessageButton.vue?vue&type=script&lang=js&"
import style0 from "./ResendMessageButton.vue?vue&type=style&index=0&id=9d920d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d920d20",
  null
  
)

export default component.exports